import { render, staticRenderFns } from "./PlayerAds.vue?vue&type=template&id=527ae7d2&scoped=true&"
import script from "./PlayerAds.vue?vue&type=script&lang=js&"
export * from "./PlayerAds.vue?vue&type=script&lang=js&"
import style0 from "./PlayerAds.vue?vue&type=style&index=0&id=527ae7d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527ae7d2",
  null
  
)

export default component.exports